enum ButtonStyle {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary'
}

export default ButtonStyle;